<div class="ts1-signoff">
	@if (instructorForm) {
		<section class="ts1-signoff__section" [formGroup]="instructorForm">
			<div class="ts1-signoff__header">
				<span class="ts1-signoff__header-title">Instructor Sign-off</span>
				<button type="button" class="ts1-signoff__preview-btn" (click)="previewSummary.emit()">Preview Summary</button>
			</div>

			<div class="ts1-signoff__body">
				<div class="ts1-signoff__field">
					<label class="ts1-signoff__label">Instructor Name</label>
					<div class="ts1-signoff__underline">
						<input
							type="text"
							class="ts1-signoff__input"
							formControlName="trainerName"
							readonly
							placeholder="Enter full legal name"
						/>
					</div>
				</div>

				<div class="ts1-signoff__field">
					<div class="ts1-signoff__label-row">
						<label class="ts1-signoff__label">License No</label>
						<button
							type="button"
							class="ts1-signoff__toggle-row"
							(click)="toggleLicenseNumber(!useInstructorLicense?.value)"
							aria-label="Toggle between License No and Examiner No"
						>
							<span class="ts1-signoff__switch" [class.ts1-signoff__switch--examiner]="!useInstructorLicense?.value">
								<span class="ts1-signoff__switch-thumb" aria-hidden="true"></span>
							</span>
							<span
								class="ts1-signoff__toggle-label"
								[class.ts1-signoff__toggle-label--active]="!useInstructorLicense?.value"
							>
								Examiner No
							</span>
						</button>
					</div>
					<div class="ts1-signoff__underline">
						<input
							type="text"
							class="ts1-signoff__input"
							formControlName="instructorLicenseNumber"
							[placeholder]="
								useInstructorLicense?.value ? 'Enter instructors active license no' : 'Enter examiner number'
							"
						/>
					</div>
				</div>

				<div class="ts1-signoff__field">
					<label class="ts1-signoff__label">Instructor Signature</label>
					<div class="ts1-signoff__signature-wrap">
						<button
							type="button"
							class="ts1-signoff__signature"
							[disabled]="!isOnline || !signingIsValid"
							(click)="signOffModel()"
						>
							@if (instructorHasSignaturePreview) {
								<img class="ts1-signoff__signature-img" [src]="instructorSignaturePreview" alt="Instructor signature" />
							} @else {
								<span class="ts1-signoff__placeholder">Signed electronically</span>
							}
						</button>
						@if (instructorSignedAt) {
							<span class="ts1-signoff__signed-at">{{ instructorSignedAt }}</span>
						}
					</div>
				</div>
			</div>
		</section>
	}
</div>
